import React from 'react';

import PaginatedIndexQuery from '../PaginatedIndexQueryContainer';
import RankingsIndexQuery from 'buyside/graphql/queries/RanksIndexItems';

const RankIndexQueryContainer = ({ category, children }) => {
  const queryName = 'currentRanksForCategory';
  return (
    <PaginatedIndexQuery
      query={RankingsIndexQuery}
      queryName={queryName}
      pageSize={10}
      variables={{ category }}
    >
      {({ loading, data }) => {
        if (loading || !data) {
          return children({ loading: true });
        }

        const { indexItems: ranks, hasNextPage, fetchNextPage } = data;

        return children({
          loading: false,
          data: {
            ranks,
            hasNextPage,
            fetchNextPage
          }
        });
      }}
    </PaginatedIndexQuery>
  );
};

export default RankIndexQueryContainer;
